module.exports = __webpack_public_path__ + "static/media/2.5d8a632c.jpg";